// extracted by mini-css-extract-plugin
export default {"wrapper":"AddCommentNews_wrapper__DzrJA","form":"AddCommentNews_form__KoAs2"};